// extracted by mini-css-extract-plugin
module.exports = {"table":"HollowTable_table__3sb8W","noDataAvailable":"HollowTable_noDataAvailable__DynNw"};